<mat-card>
  <mat-card-title class="grid-item-title">{{ 'dataManagement.exportList.title' | transloco }}</mat-card-title>
  <mat-card-content>
    <mat-tab-group class="mat-tab-fill-height export-list-group" [preserveContent]="true" (selectedTabChange)="onTabChanged($event)">
      <mat-tab label="{{ 'dataManagement.exportList.titleSystems' | transloco }}">
        <ng-template matTabContent>
          <div class="export-list-table-container">
            <div class="export-table">
              <app-export-list-table
                [dataSource]="systemDataSource"
                [displayedColumns]="systemDisplayedColumns"
                [pageSize]="defaultPageSize"
                [pageSizeOptions]="pageSizeOptions"
                [organizations]="$organizations()"
                (changeTrackingEvent)="changeTracking($event, packagingPartEnum.System)"
                (deleteImportEvent)="deleteImport($event, packagingPartEnum.System)" />
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="{{ 'dataManagement.exportList.titleUnits' | transloco }}">
        <ng-template matTabContent>
          <div class="export-list-table-container">
            <div class="export-table">
              <app-export-list-table
                [dataSource]="unitDataSource"
                [displayedColumns]="unitDisplayedColumns"
                [pageSize]="defaultPageSize"
                [pageSizeOptions]="pageSizeOptions"
                [organizations]="$unitOrganizations()"
                (changeTrackingEvent)="changeTracking($event, packagingPartEnum.Unit)"
                (deleteImportEvent)="deleteImport($event, packagingPartEnum.Unit)" />
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="{{ 'dataManagement.exportList.titleComponents' | transloco }}">
        <ng-template matTabContent>
          <div class="export-list-table-container">
            <div class="export-table">
              <app-export-list-table
                [dataSource]="componentDataSource"
                [displayedColumns]="componentDisplayedColumns"
                [pageSize]="defaultPageSize"
                [pageSizeOptions]="pageSizeOptions"
                [organizations]="$componentOrganizations()"
                (changeTrackingEvent)="changeTracking($event, packagingPartEnum.Component)"
                (deleteImportEvent)="deleteImport($event, packagingPartEnum.Component)" />
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="{{ 'dataManagement.exportList.titleMaterials' | transloco }}">
        <ng-template matTabContent>
          <div class="export-list-table-container">
            <div class="export-table">
              <app-export-list-table
                [dataSource]="materialDataSource"
                [displayedColumns]="materialDisplayedColumns"
                [pageSize]="defaultPageSize"
                [pageSizeOptions]="pageSizeOptions"
                [organizations]="$materialOrganizations()"
                (changeTrackingEvent)="changeTracking($event, packagingPartEnum.Material)"
                (deleteImportEvent)="deleteImport($event, packagingPartEnum.Material)" />
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
